import React from 'react';
import classNames from 'classnames';
import styles from '../../styles/layout.module.css';

export default function Container({ children, className }) {
  return <div className={classNames(styles.container, className)}>{children}</div>;
} 